<template>
  <div id="appNavbar">
    <v-navigation-drawer v-model="sideNav" fixed temporary color="#fffcf5">
      <v-layout wrap>
        <v-flex xs12 text-center py-4>
          <router-link to="/">
            <v-img contain height="60px" :src="require('./../../public/wtilogo.png')" />
          </router-link>
        </v-flex>

        <v-flex xs12 text-left py-2 align-self-center>
          <v-list dense class="sidebar-list">
            <div
              v-for="(main, i) in restructuredAppMenu"
              :key="i"
              class="menu-wrapper"
            >
              <router-link
                v-if="main.name === 'Dashboard'"
                :to="main.route"
                class="menu-link"
              >
                <v-list-item class="main-menu-item" :class="{'active-main': $route.path === main.route}">
                  <v-list-item-icon class="mr-3">
                    <v-icon :color="$route.path === main.route ? '#005f32' : 'black'">{{ main.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="menu-title" :style="{'color': $route.path === main.route ? '#005f32' : 'black'}">
                      {{ main.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>

              <div v-else>
                <v-list-item class="main-menu-item" @click="clickedMenu = clickedMenu === i ? null : i" :class="{'active-main': clickedMenu === i || isActiveMenu(main)}">
                  <v-list-item-icon class="mr-3">
                    <v-icon :color="clickedMenu === i || isActiveMenu(main) ? '#005f32' : 'black'">{{ main.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="menu-title" :style="{'color': clickedMenu === i || isActiveMenu(main) ? '#005f32' : 'black'}">
                      {{ main.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon :color="clickedMenu === i || isActiveMenu(main) ? '#005f32' : 'black'" small>
                      {{ clickedMenu === i ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>

                <transition name="smooth-menu">
                  <div v-show="clickedMenu === i" class="submenu-container">
                    <div class="submenu-card-mobile">
                      <template v-for="(sub, j) in main.submenus">
                        <!-- if level 2 has level 3 items -->
                        <v-list-group
                          v-if="sub.submenus && sub.submenus.length > 0"
                          :key="j"
                          no-action
                          sub-group
                          class="level2-group"
                          :value="openSubGroup === `${i}-${j}`"
                          @input="val => openSubGroup = val ? `${i}-${j}` : null"
                        >
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title class="sub-menu-title">{{ sub.name }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                          
                          <v-list-item
                            v-for="(subSub, k) in sub.submenus"
                            :key="k"
                            :to="subSub.route"
                            class="level3-item"
                            active-class="activated-sub"
                          >
                            <v-list-item-content>
                              <v-list-item-title class="subsub-menu-title">{{ subSub.name }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>

                        <!-- if level 2 is just a link -->
                        <v-list-item
                          v-else
                          :key="j"
                          :to="sub.route || '/'"
                          class="level2-item"
                          active-class="activated-sub"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="sub-menu-title">{{ sub.name }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </v-list>
        </v-flex>
      </v-layout>
      <!-- <v-layout wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in appNavItems"
          :key="i"
          text-center
          pa-2
          pl-0
          text-none
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12 px-0 pl-2 align-self-center text-left>
              <router-link :to="item.route">
                <v-icon>{{ item.icon }}</v-icon>
                <span
                  :style="
                    $route.path == item.route
                      ? {
                          'font-family': 'poppinsbold',
                        }
                      : {
                          'font-family': 'poppinslight',
                        }
                  "
                  style="
                    font-size: 15px;
                    color: black;
                    letter-spacing: 3px;
                    cursor: pointer;
                  "
                >
                  {{ item.name }}
                </span>
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
    </v-navigation-drawer>

    <v-app-bar
      app
      dark
      color="#fffcf5"
      dense
      flat
      height="50px"
      class="hidden-lg-and-up"
    >
      <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
        <v-icon color="#005f32">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="pl-4">
        <span style="font-family: kumbhBold; font-size: 20px; color: #000;">
          {{ pageTitle }}
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon color="#005f32" class="mr-2" @click="$route.path !== '/notifications' ? $router.push('/notifications') : null">
        <v-badge :value="notifications.length > 0" dot color="red" overlap>
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
      <AccountMenu />
    </v-app-bar>
    <v-layout wrap justify-end class="hidden-md-and-down">
      <v-flex lg12 align-self-center>
        <v-app-bar
          color="#fffcf5"
          elevation="0"
          height="70px"
          class="hidden-md-and-down"
        >
          <v-layout wrap justify-center fill-height>
            <v-flex xs6 align-self-center text-left pl-10>
              <span style="font-family: kumbhBold; font-size: 24px; color: rgb(30, 97, 45);">
                {{ pageTitle }}
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs6 lg1 xl1 px-4 text-center align-self-center style="cursor:pointer" v-if="appUser.positionid">
                <div v-if="appUser.positionid.length>1">
                    <SwitchAccount />
                </div>
               
            </v-flex>
            <v-flex shrink px-2 align-self-center>
              <v-btn icon color="#005f32" @click="$route.path !== '/notifications' ? $router.push('/notifications') : null">
                <v-badge :value="notifications.length > 0" dot color="red" overlap>
                  <v-icon size="28">mdi-bell-outline</v-icon>
                </v-badge>
              </v-btn>
            </v-flex>
            <v-flex xs6 lg1 xl1 px-4 text-center align-self-center style="cursor:pointer">
              <AccountMenu />
            </v-flex>
          </v-layout>
        </v-app-bar>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import AccountMenu from "./../components/accountMenu";
import SwitchAccount from "./../components/switchAccount";
import axios from "axios";
export default {
  components: {
    AccountMenu,
    SwitchAccount,
  },
  data() {
    return {
      apiNotifications: [],
      isRM: false,
      sideNav: false,
      clickedMenu: null,
      openSubGroup: null,
      admin: [{ name: "ADMINS", route: "/Admins" }],
      menus: [
        {
          name: "Dashboard",
          subMenu: [
            {
              name: "Dashboard",
              route: "/",
            },
          ],
        },

        {
          name: "Category",
          subMenu: [
            {
              name: "Category List",
              route: "/CategoryList",
            },
          ],
        },
        {
          name: "Job Title",
          subMenu: [
            {
              name: "Title List",
              route: "/TitleList",
            },
          ],
        },
        {
          name: "Volunteer Title",
          subMenu: [
            {
              name: "Title List",
              route: "/Volunteer",
            },
          ],
        },
        {
          name: " Job Applications",
          subMenu: [
            {
              name: "Applications",
              route: "/Applications",
            },
          ],
        },
        {
          name: "Volunteer Applications",
          subMenu: [
            {
              name: "Volunteer Applications",
              route: "/volunteerApplication",
            },
          ],
        },
        {
          name: "Employee ",
          subMenu: [
            {
              name: "All Employees",
              route: "/employeelist",
            },
            {
              name: "Employee Folder",
              route: "/employeedocument",
            },
          ],
        },

        {
          name: "Products",
          subMenu: [
            {
              name: "Products",
              route: "/products",
            },
            {
              name: "Add Product",
              route: "/addProducts",
            },
            {
              name: "Add Product-Type",
              route: "/ProductType",
            },
          ],
        },

        {
          name: "Purchase",
          subMenu: [
            {
              name: "Purchase",
              route: "/purchaseReports",
            },
          ],
        },

        {
          name: "About Us",
          subMenu: [
            {
              name: "About us",
              route: "/aboutUs",
            },
            {
              name: "Video",
              route: "/Video",
            },
            {
              name: "Announcements",
              route: "/Announcements",
            },
          ],
        },
      ],
      NewEmpMenu: [
        {
          menu: {
            name: "Dashboard",
          },
          submenus:[
            {
              route:"/",
              name:"Dashboard"
            }
          ]
        },
        {
          menu: {
            name: "Employee Onboarding",
          },
          submenus: [
            {
              route: "/orientation",
              name: "Orientation"
            }
          ]
        },
      ],
    };
  },
  methods: {
    isActiveMenu(main) {
      if (!main.submenus) return false;
      return main.submenus.some(sub => {
        if (sub.route === this.$route.path) return true;
        if (sub.submenus) {
          return sub.submenus.some(ss => ss.route === this.$route.path);
        }
        return false;
      });
    },
    async handleNotificationClick(n) {
      let r = n.route;
      
      if (n.id) {
        try {
          const token = localStorage.getItem('token');
          await axios.get(`/notification/markasread?id=${n.id}`, { headers: { 'x-auth-token': token } });
          this.apiNotifications = this.apiNotifications.filter(x => x._id !== n.id && x.id !== n.id);
        } catch (e) {
          console.error("Error marking notification as read:", e);
        }
      }

      if (r) {
        if (r === '/profile') {
          r = '/my-profile';
        } else if (r.startsWith('employee/leave/application/view/')) {
          const id = r.split('employee/leave/application/view/')[1];
          r = `/Attendance/leaveRequestsDetails?id=${id}`;
        } else if (r.startsWith('travelLog/view/')) {
          const id = r.split('travelLog/view/')[1];
          r = `/Attendance/travelRequestDetails?id=${id}`;
        } else if (!r.startsWith('/')) {
          r = '/' + r;
        }

        if (this.$route.fullPath !== r) {
          this.$router.push(r).catch(()=>{});
        }
      }
    },
    async fetchUnreadNotifications() {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const notifRes = await axios.get('/notification/getunreadlist', { headers: { 'x-auth-token': token } });
          if (notifRes.data && notifRes.data.status) {
            this.apiNotifications = notifRes.data.data;
          }
        } catch(e) {
          console.error("Error fetching notifications:", e);
        }
      }
    }
  },
  async created() {
    this.$root.$on('notifications-read', this.fetchUnreadNotifications);
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const res = await axios.get('/career-graph/is-manager', { headers: { 'x-auth-token': token } });
        this.isRM = res.data && res.data.isRM;
      } catch(e) {
        console.error("Error fetching manager status:", e);
      }
      this.fetchUnreadNotifications();
    }
  },
  beforeDestroy() {
    this.$root.$off('notifications-read', this.fetchUnreadNotifications);
  },
  computed: {
    pageTitle() {
      if (!this.$route.name) return '';
      let name = this.$route.name;
      if (name.toLowerCase() === 'dashboard') return 'Dashboard';
      name = name.replace(/-/g, ' ');
      name = name.replace(/([A-Z])/g, ' $1').trim();
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    appUser() {
      return this.$store.state.userData;
    },
    appMenu() {
      return this.$store.state.menus;
    },
    appLogin() {
      return false;
    },
    appType() {
      return this.$store.state.userType;
    },
    appNavItems() {
      if (this.$store.state.menus.length > 0 && this.$store.state.positionId != null) {
        return this.$store.state.menus;
      } else {
        return this.NewEmpMenu;
      }
    },
    restructuredAppMenu() {
      const menus = this.appNavItems || [];
      const structure = [
        { name: "Dashboard", icon: "mdi-home", submenus: [], route: "/" },
        { name: "Employee Onboarding", icon: "mdi-account-check", submenus: [] },
        { name: "Recruitment & Onboarding", icon: "mdi-account-multiple-plus", submenus: [] },
        { name: "Time Management", icon: "mdi-clock-check-outline", submenus: [] },
        { name: "Employee Master Data", icon: "mdi-card-account-details-outline", submenus: [] },
        { name: "Performance Management", icon: "mdi-bullseye-arrow", submenus: [] },
        { name: "Payroll Management", icon: "mdi-cash-multiple", submenus: [] },
        { name: "HR Downloads", icon: "mdi-folder-download-outline", submenus: [
          { name: "Downloads", route: "/download" }
        ] },
        { name: "Settings", icon: "mdi-cog-outline", submenus: [] },
        { name: "Technical Support", icon: "mdi-headset", submenus: [] },
        { name: "Others", icon: "mdi-dots-horizontal", submenus: [] }
      ];

      const categoryMap = {
        "job title": "Recruitment & Onboarding",
        "job applications": "Recruitment & Onboarding",
        "category": "Recruitment & Onboarding",
        
        "orientation": "Recruitment & Onboarding",
        "employee onboarding": "Employee Onboarding",
        
        "volunteer title": "Others",
        "volunteer applications": "Others",
        
        "attendance": "Time Management",
        "leave management": "Time Management",
        "travelogue": "Time Management",
        
        "employee": "Employee Master Data",
        "employee list": "Employee Master Data",
        "teams": "Employee Master Data",
        "team": "Employee Master Data",
        "employee comparison": "Employee Master Data",
        "exit management": "Employee Master Data",
        
        "targets": "Performance Management",
        "pmr": "Performance Management",
        
        "payslips": "Payroll Management",
        "loans & advances": "Payroll Management",
        
        "downloads": "HR Downloads",
        "excel reports": "HR Downloads",
        "hrmanual": "HR Downloads",
        "hr manual": "HR Downloads",
        "hr manuals": "HR Downloads",
        
        "settings": "Settings",
        "organization details": "Settings",
        
        "troubleshoot": "Technical Support",
      };

      menus.forEach(main => {
        const rawName = (main.menu && main.menu.name) ? main.menu.name : (main.name || "");
        const oldName = rawName.toLowerCase().trim();
        
        if (oldName === "download" || oldName === "downloads") {
          return;
        }

        if (oldName === "dashboard" || oldName === "home") {
          return; // Handled directly
        }
        
        if (oldName === "attendance" || oldName === "time management") {
          const attendanceItems = [];
          const leaveItems = [];
          const travelItems = [];
          const subs = main.submenus || main.subMenu || [];
          
          subs.forEach(sub => {
            const subName = (sub.name || "").toLowerCase();
            if (subName.includes("leave") || subName.includes("withdraw")) {
              leaveItems.push(sub);
            } else if (subName.includes("travel") || subName.includes("out of office") || subName.includes("on forest duty") || subName.includes("outofoffice")) {
              travelItems.push(sub);
            } else {
              attendanceItems.push(sub);
            }
          });
          
          const cat = structure.find(s => s.name === "Time Management");
          if (cat) {
            if (attendanceItems.length > 0) {
              cat.submenus.push({
                name: "Attendance",
                submenus: attendanceItems,
                route: main.route
              });
            }
            if (leaveItems.length > 0) {
              cat.submenus.push({
                name: "Leave Management",
                submenus: leaveItems,
                route: null
              });
            }
            if (travelItems.length > 0) {
              cat.submenus.push({
                name: "Travelogue",
                submenus: travelItems,
                route: null
              });
            }
          }
          return;
        }

        if (oldName === "employee" || oldName === "employees") {
          const subs = main.submenus || main.subMenu || [];
          const allLinks = [];
          const extractLinks = (items) => {
            items.forEach(item => {
              if (item.submenus && item.submenus.length > 0) {
                 extractLinks(item.submenus);
              } else {
                 allLinks.push(item);
              }
            });
          };
          extractLinks(subs);

          const employeeListGroup = [];
          const teamsGroup = [];
          const comparisonGroup = [];
          const exitGroup = [];
          const hrDownloadsGroup = [];
          const othersGroup = [];

          allLinks.forEach(link => {
            const name = (link.name || "").toLowerCase();
            if (name.includes("team")) {
              teamsGroup.push(link);
            } else if (name.includes("comparison")) {
              comparisonGroup.push(link);
            } else if (name.includes("exit") || name.includes("resigned")) {
              exitGroup.push(link);
            } else if (name.includes("forms") || name.includes("policies")) {
              hrDownloadsGroup.push(link);
            } else if (name.includes("document") || name.includes("doc") || name.includes("folder")) {
              if (name === "employee document" || name === "employee folder" || link.route === "/employeedocument") {
                employeeListGroup.push(link);
              } else {
                othersGroup.push(link);
              }
            } else {
              employeeListGroup.push(link);
            }
          });

          const cat = structure.find(s => s.name === "Employee Master Data");
          if (cat) {
             if (employeeListGroup.length > 0) {
               const formattedEmployeeListGroup = employeeListGroup.map(link => {
                 const lName = (link.name || "").toLowerCase().trim();
                 if (lName === "employee" || lName === "employee list" || link.route === "/employeelist") {
                   return { ...link, name: "All Employees" };
                 }
                 if (lName === "employee document" || lName === "employee folder" || link.route === "/employeedocument") {
                   return { ...link, name: "Employee Folder" };
                 }
                 return link;
               });
               formattedEmployeeListGroup.sort((a, b) => (a.name === "Employee Folder" || a.route === "/employeedocument") ? 1 : (b.name === "Employee Folder" || b.route === "/employeedocument") ? -1 : 0);
               cat.submenus.push({ name: "Employee List", submenus: formattedEmployeeListGroup, route: null });
             }
             if (teamsGroup.length > 0) {
               cat.submenus.push({ name: "Teams", submenus: teamsGroup, route: null });
             }

             if (comparisonGroup.length > 0) {
               cat.submenus.push({ name: "Employee Comparison", submenus: comparisonGroup, route: null });
             }
             if (exitGroup.length > 0) {
               let exitSub = cat.submenus.find(s => s.name === "Exit Management");
               if (exitSub) {
                 exitSub.submenus.push(...exitGroup);
               } else {
                 cat.submenus.push({ name: "Exit Management", submenus: exitGroup, route: null });
               }
             }
          }

          const hrCat = structure.find(s => s.name === "HR Downloads");
          if (hrCat && hrDownloadsGroup.length > 0) {
            hrDownloadsGroup.forEach(link => {
              hrCat.submenus.push({ name: link.name, submenus: link.submenus || [], route: link.route });
            });
          }

          const othersCat = structure.find(s => s.name === "Others");
          if (othersCat && othersGroup.length > 0) {
            othersGroup.forEach(link => {
              othersCat.submenus.push({ name: link.name, submenus: link.submenus || [], route: link.route });
            });
          }
          return;
        }

        if (oldName === "exit interview") {
          const cat = structure.find(s => s.name === "Employee Master Data");
          if (cat) {
            let exitSub = cat.submenus.find(s => s.name === "Exit Management");
            if (exitSub) {
              exitSub.submenus.push({
                 name: rawName,
                 submenus: main.submenus || main.subMenu || [],
                 route: main.route
              });
            } else {
              cat.submenus.push({
                 name: "Exit Management",
                 submenus: [{ name: rawName, submenus: main.submenus || main.subMenu || [], route: main.route }],
                 route: null
              });
            }
          }
          return;
        }

        const newCategoryName = categoryMap[oldName] || "Others";
        const cat = structure.find(s => s.name === newCategoryName);
        if (cat) {
          cat.submenus.push({
            name: rawName,
            submenus: main.submenus || main.subMenu || [],
            route: main.route
          });
        }
      });

      const recCat = structure.find(s => s.name === "Recruitment & Onboarding");
      if (recCat) {
        const orderMap = {
          "job title": 1,
          "volunteer title": 2,
          "job application": 3,
          "job applications": 3,
          "volunteer applications": 4,
          "orientation": 5,
          "category": 6
        };
        recCat.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = orderMap[nameA] || 99;
          const orderB = orderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const timeCat = structure.find(s => s.name === "Time Management");
      if (timeCat) {
        const timeOrderMap = {
          "attendance": 1,
          "leave management": 2,
          "travelogue": 3
        };
        timeCat.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = timeOrderMap[nameA] || 99;
          const orderB = timeOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const empCat = structure.find(s => s.name === "Employee Master Data");
      if (empCat) {
        const empOrderMap = {
          "employee list": 1,
          "teams": 2,
          "team": 2,
          "employee comparison": 3,
          "exit management": 4
        };
        const teamSubs = empCat.submenus.filter(sub => {
           const n = (sub.name || "").toLowerCase().trim();
           return n === "teams" || n === "team";
        });
        
        let teamsSub;
        if (teamSubs.length > 0) {
           teamsSub = teamSubs[0];
           teamsSub.name = "Teams";
           if (!teamsSub.submenus) teamsSub.submenus = [];
           // merge the rest and remove them
           for (let i = 1; i < teamSubs.length; i++) {
              if (teamSubs[i].submenus) {
                 teamsSub.submenus.push(...teamSubs[i].submenus);
              }
              const idx = empCat.submenus.indexOf(teamSubs[i]);
              if (idx > -1) empCat.submenus.splice(idx, 1);
           }
        } else {
           teamsSub = { name: "Teams", submenus: [], route: null };
           empCat.submenus.push(teamsSub);
        }
        
        const hasOrg = teamsSub.submenus.find(s => (s.name || "").toLowerCase().includes("organogram"));
        if (!hasOrg) teamsSub.submenus.push({ name: "Team Organogram", route: "/admin/teams/list" });

        empCat.submenus.forEach(sub => {
           const lowerName = (sub.name || "").toLowerCase().trim();
           if (lowerName === "employee list") {
             sub.name = "Employee List";
             if (sub.submenus) {
               sub.submenus.forEach(nested => {
                 const nName = (nested.name || "").toLowerCase().trim();
                 if (nName === "employee" || nName === "employee list" || nested.route === "/employeelist") {
                   nested.name = "All Employees";
                 }
               });
             }
           }
           if (lowerName === "employee comparison") sub.name = "Employee Comparison";
           if (lowerName === "exit management") sub.name = "Exit Management";
        });
        empCat.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = empOrderMap[nameA] || 99;
          const orderB = empOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const hrCatSort = structure.find(s => s.name === "HR Downloads");
      if (hrCatSort) {
        const hrOrderMap = {
          "downloads": 1,
          "forms & policies": 2,
          "hrmanual": 3,
          "hr manuals": 3,
          "hr manual": 3
        };
        hrCatSort.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = hrOrderMap[nameA] || 99;
          const orderB = hrOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const payrollCatSort = structure.find(s => s.name === "Payroll Management");
      if (payrollCatSort) {
        const payrollOrderMap = {
          "payslips": 1,
          "loans & advances": 2
        };
        payrollCatSort.submenus.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase().trim();
          const nameB = (b.name || "").toLowerCase().trim();
          const orderA = payrollOrderMap[nameA] || 99;
          const orderB = payrollOrderMap[nameB] || 99;
          return orderA - orderB;
        });
      }

      const positionId = this.$store.state.positionId || localStorage.getItem("positionId");
      const isAdmin = positionId === "62a2de91ecd959516cd3b0e6";

      const settingsCat = structure.find(s => s.name === "Settings");
      if (settingsCat && isAdmin) {
        settingsCat.submenus.push({
          name: "Automation Tools",
          submenus: [
            { name: "Actions", route: "/AutomationTools/Actions" },
            { name: "Send Email", route: "/AutomationTools/SendEmail" }
          ],
          route: null
        });
      }

      const globalOthersCat = structure.find(s => s.name === "Others");
      if (globalOthersCat && isAdmin) {
        globalOthersCat.submenus.push({
          name: "Fake GPS List",
          submenus: [],
          route: "/fake-gps/list"
        });
        globalOthersCat.submenus.push({
          name: "Audit Logs",
          submenus: [],
          route: "/audit-logs"
        });
      }

      const empOnboardingCat = structure.find(s => s.name === "Employee Onboarding");
      if (empOnboardingCat && empOnboardingCat.submenus.length === 0 && !isAdmin) {
        empOnboardingCat.submenus.push({
          name: "Orientation",
          submenus: [],
          route: "/orientation"
        });
      }

      const pmCat = structure.find(s => s.name === "Performance Management");
      if (pmCat) {
        const hasCareerGraph = pmCat.submenus.find(s => s.name.toLowerCase() === "career graph");
        if (!hasCareerGraph) {
          const cgSubmenus = [];
          if (isAdmin) {
            cgSubmenus.push({ name: "Upload", route: "/CareerGraphUpload", submenus: [] });
          }
          cgSubmenus.push({ name: "Career Graph", route: "/CareerGraphDivision", submenus: [] });
          if (!isAdmin && this.isRM) {
            cgSubmenus.push({ name: "My Career Graph", route: `/CareerGraphView/${localStorage.getItem('userid')}`, submenus: [] });
          }

          pmCat.submenus.push({
            name: "Career Graph",
            submenus: cgSubmenus,
            route: null
          });
        }
      }

      // Add "My Team" for regular employees/managers
      if (!isAdmin) {
        structure.push({
          name: "My Team",
          icon: "mdi-account-group",
          submenus: [
            { name: "Team Members", route: "/my-team/members" },
            { name: "Team Organogram", route: "/my-team/organogram" }
          ],
          route: null
        });
      }

      return structure.filter(c => {
        if (c.name === "Dashboard") return true;
        if (c.name === "Others" && !isAdmin) return false;
        if (c.name === "Employee Onboarding" && isAdmin) return false;
        if (c.name === "Employee Master Data" && !isAdmin) return false;
        if (c.name === "Settings" && !isAdmin) return false;
        return c.submenus.length > 0;
      });
    },
    notifications() {
      const notifs = [];
      if (this.appUser && this.appUser.status === 'Incomplete') {
        notifs.push({
          title: "Profile Incomplete",
          message: "Welcome! Please complete your profile section to proceed with all portal features.",
          route: "/my-profile"
        });
      }
      if (this.apiNotifications && this.apiNotifications.length > 0) {
        this.apiNotifications.forEach(apiNotif => {
          notifs.push({
            id: apiNotif._id || apiNotif.id,
            title: apiNotif.title,
            message: apiNotif.body,
            route: apiNotif.route
          });
        });
      }
      return notifs;
    },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: kumbhRegular !important;
}
input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: kumbhRegular !important;
}
.searchBox .v-input__control {
  min-height: 10px !important;
}
.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}

.menu-wrapper {
  position: relative;
  margin-bottom: 4px;
}
.main-menu-item {
  border-radius: 8px;
  margin: 0 12px;
  padding: 4px 16px;
  transition: all 0.3s;
  cursor: pointer;
}
.main-menu-item.active-main {
  background-color: #f0f0f0 !important;
  color: #005f32 !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.menu-link {
  text-decoration: none;
}
.menu-title {
  font-family: kumbhMedium;
  font-size: 14px;
  letter-spacing: 0.5px;
  white-space: normal !important;
  line-height: 1.2;
}
.submenu-container {
  padding: 0 12px;
  margin-top: 4px;
}
.submenu-card-mobile {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 8px 0;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
}
.submenu-card-mobile .v-list-item__title {
  color: #333333 !important;
}
.submenu-card-mobile .v-icon {
  color: #666666 !important;
}
.sub-menu-title {
  font-family: kumbhMedium;
  font-size: 13px;
  white-space: normal !important;
  line-height: 1.2;
}
.subsub-menu-title {
  font-family: kumbhRegular;
  font-size: 12px;
  white-space: normal !important;
  line-height: 1.2;
}
.level2-item, .level2-group {
  margin-bottom: 2px;
  cursor: pointer;
}
.activated-sub {
  background-color: rgba(0, 95, 50, 0.1);
}
.activated-sub .sub-menu-title,
.activated-sub .subsub-menu-title,
.activated-sub .v-icon {
  color: #005f32 !important;
  font-family: kumbhEBold;
}
.smooth-menu-enter-active, .smooth-menu-leave-active {
  transition: max-height 0.15s ease-out, opacity 0.15s ease-out;
  overflow: hidden;
}
.smooth-menu-enter, .smooth-menu-leave-to {
  max-height: 0;
  opacity: 0;
}
.smooth-menu-enter-to, .smooth-menu-leave {
  max-height: 500px;
  opacity: 1;
}
</style>
